module.exports = __webpack_public_path__ + "static/media/search-blue.b9cd9493.svg";